<div>
  <ng-template #inputContent>
    <mat-form-field style="width: 100%">
      <mat-label>{{ label }}</mat-label>
      {{ high }}
      <input
        #inputElement
        class="big"
        [attr.inputmode]="inputModeType"
        [attr.name]="name || formCtrlName"
        [attr.autocomplete]="autocomplete"
        faxeAutofocus
        [appAutofocus]="inputAutoFocus"
        [maxlength]="maxInputlength"
        [placeholder]="placeholder"
        [required]="requiredInput"
        [type]="inputType"
        formControlName="value"
        matInput
        max="5"
        min="1"
      />
      @if (hint) {
      <mat-hint>
        {{ hint }}
      </mat-hint>
      }
    </mat-form-field>
    @if (formGroup.get('valid')?.errors?.error) {
    <mat-error>
      {{ formGroup.get('valid')?.errors?.error['msg'] }}
    </mat-error>
    }
  </ng-template>

  @if (renderFormElement) {
  <form [formGroup]="formGroup">
    <ng-container *ngTemplateOutlet="inputContent"></ng-container>
  </form>
  } @else {
  <div [formGroup]="formGroup">
    <ng-container *ngTemplateOutlet="inputContent"></ng-container>
  </div>
  }
</div>
